import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import _ from "lodash";
import { ICountry, ILang } from "../interface";
import locales from "locale-codes";
import {
  REGEXP_FOR_SPL_URLS,
  SPECIAL_COUNTRIES,
} from "../constants/specialCountries";

const MissCountries = [
  {
    name: "arabia",
    replace: "United Arab Emirates",
  },
  {
    name: "russia",
    replace: "Russian Federation",
  },
  {
    name: "tanzania",
    replace: "Tanzania, United Republic of",
  },
];

function handleCountryCode(
  countries: ICountry[],
  url: string,
  searchParam: URLSearchParams,
  setCountryIsoCode: (code?: string) => void
) {
  const path = location.href.split("/").pop();
  const country = url.split("/")[2] || searchParam.get("country") || "";

  if (path?.match(REGEXP_FOR_SPL_URLS)) {
    const countryName = path.match(REGEXP_FOR_SPL_URLS)?.at(0);
    const country = SPECIAL_COUNTRIES.find(
      (country) => country.name === countryName
    );
    if (country) {
      setCountryIsoCode(country.countryIso3);
      localStorage.setItem("countryCode", country.countryIso3);
    }
    return;
  }

  const isoCode = _.find(countries, (obj) =>
    _.isEqual(
      _.lowerCase(obj["name"]),
      _.lowerCase(_.find(MissCountries, ["name", country])?.replace || country)
    )
  )?.isoCode;

  setCountryIsoCode(isoCode);

  if (isoCode) {
    localStorage.setItem("countryCode", isoCode);
  }
}

function handleLanguageCode(
  langs: ILang[],
  url: string,
  locale: string,
  setLanguageIsoCode: (code?: string) => void
) {
  const path = location.href.split("/").pop();

  if (path?.match(REGEXP_FOR_SPL_URLS)) {
    const countryName = path.match(REGEXP_FOR_SPL_URLS)?.at(0);
    const country = SPECIAL_COUNTRIES.find(
      (country) => country.name === countryName
    );
    if (country) {
      setLanguageIsoCode(country.langIso3);
      localStorage.setItem("languageCode", country.langIso3);
    }

    return;
  }

  if (url.toString().includes("/uk_ua/ukraine/")) {
    const lang = "UKR";
    localStorage.setItem("languageCode", lang);
    return;
  }

  const lang = _.find(langs, (obj) =>
    _.isEqual(obj["englishName"], locale)
  )?.isoCode;

  setLanguageIsoCode(lang);

  if (lang) {
    localStorage.setItem("languageCode", lang);
  }
}

function useURLParameter(url: string, countries: ICountry[], langs: ILang[]) {
  const [languageIsoCode, setLanguageIsoCode] = useState<string>();
  const [countryIsoCode, setCountryIsoCode] = useState<string>();
  const [searchParam] = useSearchParams();

  let locale = locales.getByTag(
    (searchParam.get("language") ?? url.split("/")[1] ?? "").replace(
      /([a-z]{2})_([a-z]{2})/,
      (__, p2, p3) => {
        return `${p2}-${_.upperCase(p3)}`;
      }
    )
  )?.name;

  if (!locale) {
    if (url?.toString().includes("/no_no/norway/")) {
      locale = "Norwegian";
    } else if (url?.toString().includes("/sr_rs/serbia/")) {
      locale = "Serbian";
    }
  }

  useEffect(
    () => handleCountryCode(countries, url, searchParam, setCountryIsoCode),
    [countries, url]
  );

  useEffect(
    () => handleLanguageCode(langs, url, locale, setLanguageIsoCode),
    [langs, url]
  );

  return { languageIsoCode, countryIsoCode };
}

export default useURLParameter;
